var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2653,
    height: 500,
    viewBox: "0 0 2653 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3253_15332)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M714.26 213.293L695.967 339.953H762.437L782.661 198.019H892.055L899.904 141.873H803.55C795.46 141.873 787.551 144.529 781.092 149.359L748.551 173.81L728.749 188.722C720.841 194.698 715.649 203.513 714.26 213.293Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M939.387 63.0278L947.778 4.88965H744.265L724.523 141.873H769.561C781.937 141.873 792.381 132.818 794.132 120.562L802.343 63.0278H939.326H939.387Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1139.46 4.88965H1003.44L955.204 339.954H1021.67L1039.91 213.776H1096.6L1136.98 339.954H1208.89L1160.65 198.563C1198.08 187.696 1224.16 161.072 1231.1 115.249L1233.04 99.0094C1242.39 34.9548 1201.04 4.88965 1139.46 4.88965ZM1166.57 101.485L1163.61 121.649C1159.62 147.307 1136.98 159.623 1113.8 160.106H1047.81L1061.58 63.0278H1126.66C1153.22 63.0278 1170.01 76.3096 1166.57 101.485Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1508.51 63.0278L1516.84 4.88965H1312.91L1264.61 339.954H1478.45L1486.84 282.298H1339.47L1351.79 197.536H1461.18L1469.09 141.873H1359.7L1371.05 63.0278H1508.51Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1596.23 4.88965L1547.45 339.954H1613.92L1662.7 4.88965H1596.23Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1844.54 204.963H1896.76L1886.44 275.9C1868.69 283.748 1850.94 287.189 1828.79 287.189C1791.29 287.189 1764.25 270.466 1770.1 230.56L1786.89 115.25C1792.32 77.8194 1828.79 58.1381 1866.7 58.1381C1904.61 58.1381 1925.32 67.4958 1947.48 82.2869L1978.02 31.9971C1951.94 13.2818 1915.48 0 1871.65 0C1797.21 0 1731.71 36.4646 1720.9 110.36L1702.67 234.967C1692.28 306.931 1748.97 344.844 1820.39 344.844C1872.62 344.844 1913 329.57 1948.99 305.965L1971.63 151.232H1852.39L1844.54 204.963Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2268.78 4.88965L2248.07 146.764H2111.57L2131.79 4.88965H2065.26L2016.96 339.954H2083.49L2102.69 204.962H2239.68L2220 339.954H2286.46L2335.24 4.88965H2268.78Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2387.95 4.9502L2379.56 63.0883H2643.26L2652.14 4.9502H2387.95ZM2505.31 80.5962L2477.6 63.0883L2437.21 339.893H2504.35L2533.26 141.572C2536.77 117.483 2525.84 93.6365 2505.31 80.5962Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690.896 379.8L673.69 498.31H697.175L714.441 379.8H690.896Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M832.347 379.8L820.333 461.664L782.178 379.8H759.901L742.816 498.31H764.429L776.262 416.747L814.598 498.31H836.754L853.96 379.8H832.347Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M937.394 429.847C921.034 424.414 915.781 421.094 917.17 412.219C918.377 403.706 926.105 398.816 936.67 398.816C947.235 398.816 955.144 401.775 963.716 409.261L976.576 393.081C966.312 382.637 953.272 378.229 938.964 378.229C917.894 378.229 896.643 389.761 893.685 412.943C891.21 431.538 902.379 441.318 924.535 448.261C940.715 453.513 945.424 456.834 944.216 465.889C942.948 474.402 934.979 479.473 923.992 479.473C913.004 479.473 901.654 474.764 894.349 466.071L880.947 481.405C889.338 493.238 906.061 499.698 921.879 499.698C945.786 499.698 964.199 487.684 967.52 465.044C969.995 447.235 959.551 436.79 937.394 429.847Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1091.22 379.8L1079.69 458.887C1077.82 472.652 1064.72 479.655 1053.25 479.655C1040.87 479.655 1030.61 473.92 1032.66 458.887L1044.19 379.8H1020.65L1009.18 460.155C1005.13 486.96 1025.9 500 1050.47 500C1075.04 500 1099.07 487.805 1103.05 460.155L1114.71 379.8H1091.22Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1208.28 379.8H1160.17L1143.08 498.31H1166.63L1173.09 453.695H1193.13L1207.38 498.31H1232.85L1215.77 448.262C1228.99 444.458 1238.23 435.04 1240.64 418.86L1241.37 413.065C1244.69 390.425 1230.02 379.8 1208.28 379.8ZM1217.82 413.97L1216.8 421.094C1215.41 430.15 1207.38 434.497 1199.23 434.678H1175.86L1180.75 400.387H1203.76C1213.11 400.387 1219.09 405.096 1217.82 413.97Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1343.27 378.773H1317.13L1261.23 498.31H1287.01L1298.66 471.082H1334.4L1338.02 498.31H1363.62L1343.27 378.773ZM1305.78 452.125L1326.19 405.941L1332.83 452.125H1305.78Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1489.92 379.8L1477.9 461.664L1439.75 379.8H1417.47L1400.39 498.31H1422L1433.83 416.747L1472.17 498.31H1494.26L1511.53 379.8H1489.92Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1572.81 418.679C1574.74 405.941 1586.09 398.817 1598.29 398.817C1609.76 398.817 1617.24 401.956 1623.16 406.967L1635.23 389.942C1626.48 381.913 1615.49 378.049 1599.49 378.049C1575.28 378.049 1553.13 391.995 1549.5 417.291L1543.05 461C1539.36 486.96 1557.84 500 1582.05 500C1598.77 500 1609.39 496.861 1620.08 489.193L1613.8 472.531C1606.62 477.179 1597.08 479.655 1586.94 479.655C1573.71 479.655 1564.84 473.919 1566.89 459.792L1572.81 418.679Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1742.51 400.387L1745.47 379.8H1673.33L1656.24 498.31H1731.89L1734.85 477.904H1682.75L1687.09 447.96H1725.79L1728.57 428.218H1689.87L1693.91 400.387H1742.51Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1886.56 379.8H1844.42L1827.34 498.31H1867.91C1894.05 498.31 1916.87 486.598 1921.21 457.015L1926.29 421.275C1930.45 393.082 1911.68 379.8 1886.56 379.8ZM1902.74 423.207L1898.03 455.265C1895.8 471.444 1882.76 477.904 1870.86 477.904H1853.48L1864.59 400.387H1883.6C1895.98 400.387 1905.04 406.967 1902.74 423.207Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2032 378.773H2005.86L1949.95 498.31H1975.73L1987.38 471.082H2023.12L2026.81 498.31H2052.4L2032 378.773ZM1994.57 452.125L2014.91 405.941L2021.55 452.125H1994.57Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2086.15 379.8L2083.19 400.387H2117.91L2103.6 498.31H2127.26L2141.57 400.387H2176.41L2179.55 379.8H2086.15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2260.75 378.773H2234.61L2178.64 498.31H2204.42L2216.13 471.082H2251.81L2255.49 498.31H2281.09L2260.75 378.773ZM2223.26 452.125L2243.66 405.941L2250.24 452.125H2223.26Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.347 498.309L302.765 497.102L317.617 423.388L553.852 424.716L543.347 498.309Z",
    fill: "url(#paint0_linear_3253_15332)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.476 238.65L566.107 339.109L251.328 337.297L216.433 496.74L157.631 496.498L198.684 318.16C209.188 272.579 247.404 236.416 284.17 236.657L580.476 238.589V238.65Z",
    fill: "url(#paint1_linear_3253_15332)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.922 4.89049L592.973 151.232L194.76 148.515C167.713 148.334 139.278 174.354 131.128 206.955L58.923 496.137L0 495.895L83.0717 177.856C108.971 78.6046 195.545 1.63041 277.228 2.17376L613.922 4.89049Z",
    fill: "url(#paint2_linear_3253_15332)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3253_15332",
    x1: 229.051,
    y1: 509.72,
    x2: 575.284,
    y2: 425.742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#27C2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#1F9CDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#1362A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#0B3E7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#093172"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3253_15332",
    x1: 123.943,
    y1: 507.003,
    x2: 531.454,
    y2: 199.046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71D3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#3AA0DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#167FC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0973BA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3253_15332",
    x1: -76.9742,
    y1: 390.908,
    x2: 571.843,
    y2: -22.0957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71D3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008DE1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3253_15332"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2652.14,
    height: 500,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrand);
export default __webpack_public_path__ + "static/media/Brand.e1b8ace6ab4d9ef56d903f3b89ff9851.svg";
export { ForwardRef as ReactComponent };